import React from "react"
import { iconFromName } from "services/icon.service"
import { useEFSData } from "hooks/efs-input"
import StringInject from "stringinject"

export const HorizontalPlanHeader = ({ data, storeName }) => {
  const { haveHalo } = useEFSData()

  let postName = ""

  if (data.postName) {
    const templateData = {
      currentHalo: haveHalo === 1 ? "+ Halo 1" : " ",
      haloUpgrade: haveHalo === 1 ? "+ Halo 3" : "+ Halo 1"
    }

    postName = StringInject(data.postName, templateData)
  }

  return (
    <div className="plan-block hplan--header">
      <div className="hplan--header--data-amount">
        <strong>
          {data.name}
          {postName}
        </strong>
        <div className="hplan--header--data-downloads">
          <p>
            <b>Download Speed</b>
          </p>
          <p>
            {data.downloadSpeed}
            {data.downloadSpeedUnit}
          </p>
        </div>
        <div className="hplan--header--icon">
          <img
            className="hplan--header--icon-default"
            src={iconFromName(data.icon)}
            alt=""
          />

          {data.name === "Superfast Fibre Plus" && (
            <div>
              <img
                className="hplan--header--icon-btplus"
                src={iconFromName("BTPlus")}
                alt=""
              />
            </div>
          )}
        </div>
      </div>
      <div />
      {/* <div className="hplan--header--minutes-and-texts">
    <div className="hplan--header--minutes-and-texts--amount">
      {data.minutes}
    </div>
    Minutes and{" "}
    {data.minutes === data.texts ? (
      <span>Texts</span>
    ) : (
      <>
        <div className="hplan--header--minutes-and-texts--amount">
          {data.texts}
        </div>
        Texts
      </>
    )}
  </div> */}
    </div>
  )
}

export default HorizontalPlanHeader
